<p>Table with server pagination and select to correct work you should set compareWith function</p>
<aur-mat-table
  [tableConfig]="tableConfig"
  [pageSource]="loadPage">
</aur-mat-table>
